import varAxios from "../../Comman/axios";
import { 
       
         GetRegionListUrl,
         GetAuthenticationType,GetAuthenticationMethod,
         AddUserAuthenticationSettings,
         GetUserListForAuthenticationByRegionId
        }from "../../Comman/apiEndPoints"

export const FETCH_HEARTRUNNER_LIST_REQUEST1 = "(fetch) FETCH HEARTRUNNER LIST REQUEST1";
export const FETCH_HEARTRUNNER_LIST_SUCCESS1 = "(fetch) FETCH HEARTRUNNER  LIST SUCCESS1";
export const FETCH_HEARTRUNNER_LIST_ERROR = "(fetch) FETCH  HEARTRUNNER  LIST ERROR";

export const Fetch_All_Region_Data1 = "Fetch_All_Region_Data1";
export const FETCH_PERMISSIONS_LIST_DATA = "FETCH_PERMISSIONS_LIST_DATA";
export const FETCH_AUTHTYPE_LIST_DATA = "FETCH_AUTHTYPE_LIST_DATA";
export const FETCH_AUTHMETHOD_LIST_DATA = "FETCH_AUTHMETHOD_LIST_DATA";

export function fetchHeartRunnerDetail(RegionId, dispatch) {
    let data = {
        RegionId: RegionId
    }

    return (dispatch) => {
        dispatch(fetchHeartRunnerDetailRequest(true));

        return varAxios.post(GetUserListForAuthenticationByRegionId,RegionId,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    fetchHeartRunnerDetailSuccess(false, response.data.userListForAuthentication,response.data.statusCode)
                );
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        fetchHeartRunnerDetail(RegionId, dispatch)
                    );
                }
            })
    }
}

export function fetchHeartRunnerDetailRequest(isLoading) {
    return {
        type: FETCH_HEARTRUNNER_LIST_REQUEST1,
        isLoading
    }
}

export function fetchHeartRunnerDetailSuccess(isLoading, heartRunnerList,statusCode) {
    return {
        type: FETCH_HEARTRUNNER_LIST_SUCCESS1,
        isLoading,
        heartRunnerList,
        statusCode
    }
}

export function AddUserAuthenticationSetting(isLoading, payload,RegionId, dispatch) {
   
    

    return (dispatch) => {
       // dispatch(updateHeartRunnerDetailRequest(true));

        return varAxios.post(AddUserAuthenticationSettings,payload ,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
               /*  dispatch(
                    updateHeartRunnerDetailSuccess(false, 
                        response.data.heartRunnerUserList, 
                        response.data.errorMessage,
                        response.data.statusCode
                    )
                ); */
                this.fetchHeartRunnerDetail({RegionId:RegionId})
            })
            .catch((error) => {
               
            })
    }
}










export function getAllRegionSettings() {
     let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
      
       
        this.fetchHeartRunnerDetail({RegionId:response.data.regionList[0].ID})
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data1,
    errorCode,
    statusCode,
    regionList
  }
  
}

export function getAuthMethodFunc() {
    return(dispatch) => {
        
       return varAxios.get(GetAuthenticationMethod)
       .then(response => {
        
           if(response.data.statusCode == 200){
           
            dispatch(
                fetchAuthMethodData(response.data.authenticationMethodList)
                );
           }
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAuthMethodData(list) {
    return {
        type: FETCH_AUTHMETHOD_LIST_DATA,
        list
    }
}
export function getAuthTypeFunc() {
    return(dispatch) => {
        
       return varAxios.get(GetAuthenticationType)
       .then(response => {
        
           if(response.data.statusCode == 200){
           
            dispatch(
                fetchAuthTypeData(response.data.authenticationTypeList)
                );
           }
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAuthTypeData(list) {
    return {
        type: FETCH_AUTHTYPE_LIST_DATA,
        list
    }
}